<template>
  <div class="h-100" style="min-height: 1px">
    <b-overlay class="h-100" :show="loading" :blur="null" opacity="0">
      <transition name="fadeDownShort" mode="out-in">
        <div v-if="!loading" v-bar class="bar-out">
          <div>
            <b-row>
              <b-col md="6">
                <b-card class="fs-sm mb-4" title="Základné údaje">
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Názov spoločnosti </b-col>
                    <b-col sm="8">
                      <template v-if="data.name">
                        {{ data.name }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Skupina </b-col>
                    <b-col sm="8">
                      <template v-if="data.group">
                        {{ data.group.name }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Oprávnená osoba </b-col>
                    <b-col sm="8">
                      <template v-if="data.owner">
                        {{ data.owner }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Kontaktný telefón </b-col>
                    <b-col sm="8">
                      <template v-if="data.phone">
                        {{ data.phone }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Email </b-col>
                    <b-col sm="8">
                      <template v-if="data.email">
                        <b-link :href="'mailto:' + data.email">
                          {{ data.email }}
                        </b-link>
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                </b-card>
                <b-card class="fs-sm mb-4" title="Sídlo">
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Ulica </b-col>
                    <b-col sm="8">
                      <template v-if="data.street">
                        {{ data.street }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Číslo </b-col>
                    <b-col sm="8">
                      <template v-if="data.streetNumber">
                        {{ data.streetNumber }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Súp. číslo </b-col>
                    <b-col sm="8">
                      <template v-if="data.streetRegNumber">
                        {{ data.streetRegNumber }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> Mesto </b-col>
                    <b-col sm="8">
                      <template v-if="data.city">
                        {{ data.city }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                  <b-form-row class="mb-2">
                    <b-col sm="4" tag="label"> PSČ </b-col>
                    <b-col sm="8">
                      <template v-if="data.postCode">
                        {{ data.postCode }}
                      </template>
                      <template v-else> - </template>
                    </b-col>
                  </b-form-row>
                </b-card>
              </b-col>
              <b-col md="6">
                <b-card class="fs-sm mb-4" no-body>
                  <b-card-body>
                    <div
                      class="d-flex justify-content-between align-items-start"
                    >
                      <b-card-title> Údaje o spoločnosti </b-card-title>
                      <b-btn
                        v-if="data.regNumber"
                        v-b-tooltip.hover.top
                        :href="checkReg"
                        size="sm"
                        target="_blank"
                        title="Overiť vo Finstat"
                        variant="outline-secondary"
                      >
                        <icon class="icon-fw mt-1" name="registered" />
                      </b-btn>
                    </div>
                    <b-form-row class="mb-2">
                      <b-col sm="4" tag="label"> Zapísaná v </b-col>
                      <b-col sm="8">
                        <template v-if="data.registration">
                          {{ data.registration }}
                        </template>
                        <template v-else> - </template>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col sm="4" tag="label"> Druh právneho subj. </b-col>
                      <b-col sm="8">
                        <template v-if="data._form">
                          {{ data._form.name }}
                        </template>
                        <template v-else> - </template>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col sm="4" tag="label"> Vl.č. </b-col>
                      <b-col sm="8">
                        <template v-if="data.registrationCode">
                          {{ data.registrationCode }}
                        </template>
                        <template v-else> - </template>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col sm="4" tag="label"> IČO </b-col>
                      <b-col sm="8">
                        <template v-if="data.regNumber">
                          {{ data.regNumber }}
                        </template>
                        <template v-else> - </template>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col sm="4" tag="label"> DIČ </b-col>
                      <b-col sm="8">
                        <template v-if="data.taxNumber">
                          {{ data.taxNumber }}
                        </template>
                        <template v-else> - </template>
                      </b-col>
                    </b-form-row>
                    <b-form-row class="mb-2">
                      <b-col sm="4"> IČ DPH </b-col>
                      <b-col sm="8">
                        <template v-if="data.taxRegNumber">
                          {{ data.taxRegNumber }}
                        </template>
                        <template v-else> - </template>
                      </b-col>
                    </b-form-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
    </b-overlay>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      data: (state) => state.customer.current.data,
      loading: (state) => state.customer.current.loading,
    }),
    checkReg() {
      let url = 'https://www.finstat.sk/' + this.data.regNumber
      return url.replace(/\s+/g, '')
    },
  },
}
</script>
